import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { flow, pickBy, identity, tap, keys, some } from 'lodash/fp';
import { useModalProviderContext } from '../ModalProvider';
import { installationOnlyModal } from '../ModalProvider/modalNames';
import cartAsMandiJob from '../../services/cartAsMandiJob';

import ResponsiveModal from '../modals';
import {
  FlexModal,
  FlexJobOptions,
  FlexAddToCartButton,
  FlexInstallationOptions,
  FlexAddToCartButtonContainer,
  FlexProjectDetails,
} from './styles';
import useInstallationState from './useInstallationOnlyState';

const InstallationOnlyModal = ({
  designId,
  containers,
  updatePricing,
  setLoading,
  globalError,
  textOptInNumber,
}) => {
  const { isOpen } = useModalProviderContext(installationOnlyModal);
  const {
    selectedItems,
    toggleItem,
    toggleAll,
    options,
    setOption,
    pricing,
  } = useInstallationState(
    isOpen,
    designId,
    containers,
    updatePricing,
    {
      windowHaul: false,
      windowRemoval: false,
      textOptIn: true,
      textOptInNumber,
      specialInstructions: '',
      reworkType: 'install-only',
    },
    ['windowHaul', 'windowRemoval'],
  );

  const submitEnabled = useMemo(() => some(identity, selectedItems), [selectedItems]);

  const addToCart = useCallback(() => {
    setLoading(true);

    const leafItems = flow(
      pickBy(identity),
      keys,
    )(selectedItems);

    cartAsMandiJob({
      designId,
      leafItems,
      options: {
        createAndSaveJob: options,
        cartProducts: false,
      },
    })
      .then(tap(() => setLoading(false)))
      .catch(globalError);
  }, [
    designId,
    setLoading,
    globalError,
    JSON.stringify(options),
    JSON.stringify(selectedItems),
  ]);

  return (
    <ResponsiveModal
      id="installationOnlyModal"
      title="Installation Only"
      modalName={installationOnlyModal}
    >
      <FlexModal>
        <FlexProjectDetails>
          <FlexJobOptions
            id="jobOptionsPanel"
            {...options}
            onOptionChange={setOption}
            isInstallOnly
          />
          <FlexAddToCartButtonContainer>
            <FlexAddToCartButton id="addToCartButton" onClick={addToCart} disabled={!submitEnabled} />
          </FlexAddToCartButtonContainer>
        </FlexProjectDetails>
        <FlexInstallationOptions
          id="installationOptionsPanel"
          designId={designId}
          selectedItems={selectedItems}
          toggleItem={toggleItem}
          toggleAll={toggleAll}
          pricing={pricing}
        />
      </FlexModal>
    </ResponsiveModal>
  );
};
InstallationOnlyModal.propTypes = {
  designId: PropTypes.string.isRequired,
  containers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updatePricing: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  globalError: PropTypes.func.isRequired,
  textOptInNumber: PropTypes.string.isRequired,
};
export default InstallationOnlyModal;
